<template>
  <header class="main-header cyber-header">
    <div href="#" class="logo">
      <span class="logo-mini logo-mini-container">
        <div class="d-flex d-sm-none">
          <form
            class="logo-mini-custom-invite"
            v-if="$store.getters.currentUser.active"
          >
            <div class="container">
              <div class="input-group cyber-invite-group">
                <span class="input-group-addon cyber-invite-addon"
                  ><i class="icon-plane"></i
                ></span>
                <input
                  type="text"
                  class="form-control"
                  :value="referralLink"
                  v-clipboard:copy="referralLink"
                  v-clipboard:success="onCopy"
                />
              </div>
            </div>
          </form>
        </div>
      </span>
      <span class="logo-lg"></span>
    </div>

    <nav class="navbar navbar-static-top cyber-navbar">
      <a
        href="#"
        id="toggle-menu"
        class="sidebar-toggle cyber-toggle"
        data-toggle="push-menu"
        role="button"
      >
        <i class="mdi mdi-menu"></i>
        <span class="sr-only">Toggle navigation</span>
      </a>

      <div class="navbar-custom-translate translate-menu d-none d-sm-flex">
        <GoogleTranslate id="goog-translate" />
      </div>

      <div class="navbar-custom-invite">
        <form class="d-none d-sm-flex" v-if="$store.getters.currentUser.active">
          <div class="container">
            <div class="input-group cyber-invite-group">
              <span class="input-group-addon cyber-invite-addon">
                <i class="icon-plane"></i>
              </span>
              <input
                type="text"
                class="form-control"
                :value="referralLink"
                v-clipboard:copy="referralLink"
                v-clipboard:success="onCopy"
              />
            </div>
          </div>
        </form>
      </div>

      <div class="navbar-custom-menu cyber-nav-actions">
        <ul class="nav navbar-nav cyber-nav-list">
          <!-- Notification bell -->
          <li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle cyber-icon-action" data-toggle="dropdown">
              <div class="cyber-icon-action__ring">
                <i class="mdi mdi-bell-outline"></i>
              </div>
            </a>
            <ul class="dropdown-menu scale-up">
              <li class="header">No new notifications</li>
              <li>
                <ul class="menu inner-content-div"></ul>
              </li>
              <li class="footer">
                <a href="#">View all</a>
              </li>
            </ul>
          </li>

          <!-- User avatar -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle cyber-user-toggle" data-toggle="dropdown">
              <div class="cyber-user-badge">
                <img
                  :src="$store.getters.currentUser.avatar"
                  class="cyber-user-badge__img"
                  alt="User Image"
                />
                <div class="cyber-user-badge__status"></div>
              </div>
            </a>
            <ul class="dropdown-menu scale-up">
              <li class="user-header">
                <img
                  :src="$store.getters.currentUser.avatar"
                  class="float-left rounded-circle avatar"
                  alt="User Image"
                />
                <p>
                  {{ $store.getters.currentUser.username }}
                  <small class="mb-5">{{
                    $store.getters.currentUser.email
                  }}</small>
                </p>
              </li>
              <li class="user-body">
                <div class="row no-gutters">
                  <div class="col-12 text-left">
                    <router-link to="/profile">
                      <i class="ion ion-person"></i> My Profile
                    </router-link>
                  </div>
                  <div role="separator" class="divider col-12"></div>
                  <div class="col-12 text-left">
                    <a href="#" @click="logout">
                      <i class="fa fa-power-off"></i> Logout
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
.cyber-header {
  position: relative;
}

.cyber-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cyber-toggle {
  color: #B09A4E !important;
  font-size: 1.4rem !important;
  padding: 12px 18px !important;
  transition: all 0.2s ease;

  &:hover {
    color: #CDBA6E !important;
    background: rgba(176, 154, 78, 0.08) !important;
    text-shadow: 0 0 10px rgba(176, 154, 78, 0.4);
  }

  i {
    vertical-align: middle;
  }
}

.navbar-custom-translate {
  width: 20%;
}

.navbar-custom-invite {
  width: 50%;
  .container {
    width: 100%;
  }
}

.cyber-nav-actions {
  display: flex;
  align-items: center;
  height: 100%;
}

.cyber-nav-list {
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 0 10px 0 0;
  padding: 0;
  list-style: none;
  height: auto;
  float: none !important;

  > li {
    position: relative;
    float: none !important;
    display: flex;
    align-items: center;
  }
}

.cyber-invite-group {
  .form-control {
    font-size: 0.75rem !important;
    cursor: pointer;
  }
}

.cyber-invite-addon {
  background: linear-gradient(135deg, #B09A4E, #8C7A3B) !important;
  border-color: #B09A4E !important;
  color: #1a1a1a !important;
}

/* Bell icon */
.cyber-icon-action {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  background: none !important;
}

.cyber-icon-action__ring {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: transparent;
  border: 1px solid #3d3d37;
  transition: all 0.25s ease;

  i {
    font-size: 1.1rem;
    color: #9A998F;
    transition: all 0.25s ease;
    line-height: 1;
  }
}

.cyber-icon-action:hover .cyber-icon-action__ring {
  border-color: rgba(176, 154, 78, 0.3);
  background: rgba(176, 154, 78, 0.06);

  i {
    color: #B09A4E;
  }
}

/* User avatar */
.cyber-user-toggle {
  display: flex !important;
  align-items: center;
  padding: 0 !important;
  background: none !important;
}

.cyber-user-badge {
  position: relative;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

.cyber-user-badge__img {
  width: 34px !important;
  height: 34px !important;
  border-radius: 50% !important;
  object-fit: cover;
  border: 1.5px solid rgba(176, 154, 78, 0.3) !important;
  transition: all 0.25s ease;
  display: block;
}

.cyber-user-badge__status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #7BC88F;
  border: 2px solid #252525;
}

.cyber-user-toggle:hover .cyber-user-badge__img {
  border-color: #B09A4E !important;
  box-shadow: 0 0 10px rgba(176, 154, 78, 0.2);
}

.user-menu {
  .avatar {
    width: 6rem !important;
    height: 6rem !important;
    border: 2px solid rgba(176, 154, 78, 0.3);
    border-radius: 50%;
  }
}

.logo-mini {
  &-container {
    width: 100%;
  }
  &-custom-invite {
    width: 100%;
  }
}
</style>

<script>
import GoogleTranslate from "@/components/GoogleTranslate.vue";
import { userMixin } from "@/mixins";

export default {
  name: "top-menu",
  components: {
    GoogleTranslate
  },
  data() {
    return {
      model: {},
      domain: ""
    };
  },
  computed: {
    referralLink() {
      const user = this.$store.getters.currentUser;
      const branch = (user.right && 'right') || 'left';
      return this.domain + '/#/register/lineBy/' + user.username + '/branch/' + branch;
    }
  },
  mixins: [userMixin],
  methods: {
    swapLeg(leg) {
      leg = leg === "left" ? false : true;
      this.loading = true;
      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: { right: leg },
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken
        }
      })
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data);
          this.loading = false;
          this.$toasted.show("Information updated!", {
            position: "top-right",
            duration: 5000,
            type: "success",
            closeOnSwipe: true
          });
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true
              });
            });
          this.loading = false;
        });
    },
    onCopy() {
      this.$toasted.show("Copied to clipboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    }
  },

  created() {
    this.domain = process.env.VUE_APP_ROOT_DOMAIN;
  }
};
</script>
